import { io, type Socket } from "socket.io-client";
import { getWebsocketAPIUrl } from "./utils/others.utils";

let websocketAPISocket: Socket | undefined;

export const getWebsocketAPISocket = () => {
  websocketAPISocket ??= io(getWebsocketAPIUrl(), {
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
  });

  return websocketAPISocket;
};

const roomHolderCounts = new Map<string, number>();

export const joinSocketRoom = (room: string) => {
  const target = getWebsocketAPISocket();
  const join = () => target.emit("joinRoom", { room });

  roomHolderCounts.set(room, (roomHolderCounts.get(room) ?? 0) + 1);
  join();
  target.on("connect", join);

  let released = false;

  return () => {
    if (released) {
      return;
    }
    released = true;

    target.off("connect", join);

    const remainingHolders = (roomHolderCounts.get(room) ?? 1) - 1;

    if (remainingHolders > 0) {
      roomHolderCounts.set(room, remainingHolders);
      return;
    }

    roomHolderCounts.delete(room);
    target.emit("leaveRoom", { room });
  };
};

export const onSocketEvent = <TPayload>(
  event: string,
  handler: (payload: TPayload) => void
) => {
  const target = getWebsocketAPISocket();
  target.on(event, handler);

  return () => {
    target.off(event, handler);
  };
};

export const orderFileRoom = (orderId: string) => `order-file-${orderId}`;

export const helpFileRoom = (orderId: string) => `help-file-${orderId}`;
